var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskHammer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3591 27.9995H14.1992V27.2667H23.3591V27.9995ZM15.6648 26.1331C15.6652 25.8508 15.7775 25.5802 15.9771 25.3806C16.1767 25.1811 16.4473 25.0687 16.7295 25.0684H20.8288C21.111 25.0687 21.3816 25.1811 21.5812 25.3806C21.7808 25.5802 21.8931 25.8508 21.8935 26.1331V26.5339H15.6648V26.1331Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0114 21.7292L27.0646 22.6759L26.6781 22.267L27.6248 21.3203L28.0114 21.7292ZM23.0991 16.0164L21.6335 17.4819L20.9766 18.1389L17.4643 14.6266L20.2438 11.8471L23.7561 15.3594L23.0991 16.0164ZM21.8926 8L27.2368 13.3442L26.2893 14.2917L25.8156 13.818L21.7852 9.78764L20.9451 8.9475L21.8926 8ZM25.0384 14.077L24.2741 14.8413L20.7619 11.3291L21.5262 10.5648L25.0384 14.077ZM18.9614 21.6196L13.6172 16.2754L14.5647 15.3279L15.4048 16.168L19.4352 20.1984L19.9089 20.6721L18.9614 21.6196ZM16.182 15.909L16.9463 15.1447L20.4585 18.657L19.6942 19.4213L16.182 15.909ZM23.3508 16.8012L27.1214 20.7875L26.1746 21.7347L22.4055 17.7483L23.3508 16.8012ZM28.6203 23.319C28.488 23.4413 28.3154 23.5111 28.1352 23.515C28.045 23.5136 27.9559 23.4939 27.8736 23.4571C27.7912 23.4202 27.7171 23.367 27.656 23.3006L27.5688 23.2083L28.5155 22.2615L28.6361 22.3894C28.7552 22.5158 28.8203 22.6837 28.8173 22.8574C28.8144 23.0311 28.7437 23.1967 28.6203 23.319Z",
    fill: "#7BC658"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3969 21.4043H15.6641V22.8699H16.3969V21.4043Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4656 25.0684H12V25.8011H13.4656V25.0684Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3893 22.3373L12.8711 22.8555L13.9704 23.9547L14.4885 23.4366L13.3893 22.3373Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskHammer);
export default __webpack_public_path__ + "static/media/task-hammer.31c63f52d11b245c75e277aa639c3608.svg";
export { ForwardRef as ReactComponent };